const DetailsCard = ({onEnquire}) => {
  return (
    <div className="bg-white w-[340px] rounded-2xl shadow-2xl overflow-hidden">
      <div className="bg-blue-800 text-white text-center py-2 text-sm">
        Bookings Open
      </div>

      <div className="p-5 text-center">
        <h2 className="text-xl font-bold">Kamdhenu Conquest, Vashi</h2>
        <p className="text-sm text-gray-600">By Kamdhenu Realities</p>
        <p className="text-xs text-gray-500 mt-1">
          Codename - Kamdhenu Conquest @ Sec - 30A, Vashi
        </p>

        <div className="mt-4 space-y-2 text-sm text-white">
          <div className="bg-[#6B7280] py-1 rounded">
            ◆ Prime Coastal Address
          </div>
          <div className="bg-[#6B7280] py-1 rounded">
            ◆ Exclusive Grade - A Offices
          </div>
          <div className="bg-[#6B7280] py-1 rounded">
            ◆ Smart Office Layout
          </div>
        </div>

        <div className="mt-4">
          <p className="text-sm">Marquee Offices starting at</p>
          <p className="text-2xl font-bold text-[#1E40AF]">
            ₹ 1.99 Cr* Onwards
          </p>
        </div>

        <button className="mt-4 w-full bg-[#090c6a] hover:bg-[#1218A6] text-white py-2 rounded-lg font-medium" onClick={onEnquire}>
          Enquire Now
        </button>
      </div>
    </div>
  );
};

export default DetailsCard;